import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPaymentsApi,
  createPaymentApi,
  getPaymentDepositQuotesApi,
  sharePaymentApi,
  regeneratePaymentLinkApi,
  getPaymentDetailsApi,
  getSecurePaymentDetailsApi,
  deletePaymentApi,
} from "helpers/ApiManager";
import { ApiResponse, PaginatedPayload } from "types/ApiResponse";
import {
  PaymentListPayload,
  PaymentDepositQuotePayload,
  PaymentDepositQuotesQueryParams,
  PaymentsQueryParams,
  CreatePaymentArgs,
  CreatePaymentPayload,
  PaymentDetailsPayload,
  SecurePaymentDetailsPayload,
  PaymentParams,
  LinkPayload,
} from "types/payment.api";
import { SuccessToast } from "utils/toast";

export const getPayments = createAsyncThunk<
  ApiResponse<PaginatedPayload<PaymentListPayload>>,
  PaymentsQueryParams | undefined,
  { rejectValue: string }
>("payments/getPayments", async (params, { rejectWithValue }) => {
  try {
    const response = await getPaymentsApi(params);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch");
  }
});

export const createPayment = createAsyncThunk<
  ApiResponse<CreatePaymentPayload>,
  CreatePaymentArgs,
  { rejectValue: string }
>("payments/createPayment", async (params, { rejectWithValue }) => {
  try {
    const response = await createPaymentApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to create payment");
  }
});

export const getPaymentDepositQuotes = createAsyncThunk<
  ApiResponse<PaginatedPayload<PaymentDepositQuotePayload>>,
  PaymentDepositQuotesQueryParams,
  { rejectValue: string }
>("payments/getPaymentDepositQuotes", async (params, { rejectWithValue }) => {
  try {
    const response = await getPaymentDepositQuotesApi(params);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch deposit quotes");
  }
});

export const sharePayment = createAsyncThunk<
  ApiResponse<LinkPayload>,
  PaymentParams,
  { rejectValue: string }
>("payments/sharePayment", async (params, { rejectWithValue }) => {
  try {
    const response = await sharePaymentApi(params);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to share payment");
  }
});

export const regeneratePaymentLink = createAsyncThunk<
  ApiResponse<LinkPayload>,
  PaymentParams,
  { rejectValue: string }
>("payments/regeneratePaymentLink", async (params, { rejectWithValue }) => {
  try {
    const response = await regeneratePaymentLinkApi(params);
    // SuccessToast(response.message);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to regenerate payment link");
  }
});

export const getPaymentDetails = createAsyncThunk<
  ApiResponse<PaymentDetailsPayload>,
  PaymentParams,
  { rejectValue: string }
>("payments/getPaymentDetails", async (params, { rejectWithValue }) => {
  try {
    const response = await getPaymentDetailsApi(params);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch payment details");
  }
});

export const getSecurePaymentDetails = createAsyncThunk<
  ApiResponse<SecurePaymentDetailsPayload>,
  { id: number; token: string },
  { rejectValue: string }
>("payments/getSecurePaymentDetails", async (params, { rejectWithValue }) => {
  try {
    const response = await getSecurePaymentDetailsApi(params);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to fetch secure payment details");
  }
});

export const deletePayment = createAsyncThunk<
  ApiResponse<number>,
  PaymentParams,
  { rejectValue: string }
>("payments/deletePayment", async (params, { rejectWithValue }) => {
  try {
    const response = await deletePaymentApi(params.id);
    SuccessToast(response.message);
    return response;
  } catch (err: any) {
    return rejectWithValue(err?.message || "Failed to delete payment");
  }
});
